<template>
  <div
    v-if="props.phoneNumber"
    data-testid="sip-incoming-call-banner"
  >
    <v-alert
      :type="props.error ? 'error' : 'info'"
      density="compact"
      variant="elevated"
      prominent
    >
      <template #title>
        {{ props.error ? "Chiamata non risposta" : "Chiamata in arrivo" }}
      </template>
      <template #text>
        <!-- Su quale nostro numero il cliente ha chiamato: con più servizi sulla
             stessa coda è ciò che dice all'operatore come rispondere. Sopra al
             numero perché è la prima cosa da leggere. -->
        <span
          v-if="props.callerLine"
          data-testid="sip-incoming-caller-line"
          class="d-block font-weight-bold"
        >
          {{ props.callerLine }}
        </span>
        <span>{{ props.phoneNumber }}</span>
        <!-- Perché il "Rispondi" non ha risposto. Senza questo l'operatore vedeva
             solo un bottone che non faceva niente (GAIA-2664). -->
        <span v-if="props.error" data-testid="sip-incoming-error" class="d-block">
          {{ props.error }}
        </span>
      </template>
      <template #append>
        <div class="d-flex align-center ga-2">
          <!-- Il chiamante è un contatto già in Gaia: la sua scheda si apre da
               qui, nella tab in cui l'operatore sta lavorando (GAIA-2719). -->
          <v-btn
            v-if="props.leadUrl"
            color="primary"
            size="small"
            variant="tonal"
            data-testid="sip-incoming-open-lead"
            @click="emit('open-lead', props.leadUrl)"
          >
            Apri scheda
          </v-btn>
          <!-- In stato di errore non c'è più niente da rispondere: offrire il
               bottone significherebbe rifare la promessa appena mancata. -->
          <v-btn
            v-if="!props.error"
            color="success"
            size="small"
            data-testid="sip-incoming-answer"
            @click="emit('answer')"
          >
            Rispondi
          </v-btn>
          <v-btn
            variant="text"
            size="small"
            data-testid="sip-incoming-dismiss"
            @click="emit('dismiss')"
          >
            Chiudi
          </v-btn>
        </div>
      </template>
    </v-alert>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    phoneNumber: string | null
    /** Linea dichiarata dal centralino (CID Name Prefix della Inbound Route):
     *  quale dei nostri numeri il cliente ha composto. */
    callerLine?: string | null
    /** Scheda del chiamante quando è un contatto già esistente in Gaia. */
    leadUrl?: string | null
    /** Motivo per cui la risposta non è andata a buon fine: mette il banner in errore. */
    error?: string | null
  }>(),
  {
    callerLine: null,
    leadUrl: null,
    error: null,
  }
)

const emit = defineEmits<{
  (e: 'answer'): void
  (e: 'dismiss'): void
  (e: 'open-lead', url: string): void
}>()
</script>
